angular.module('Itao.IndicatorMap').directive('simpleBar', function (d3, mapConfig) {
  'use strict';

  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'districtReport/simpleBar.html',
    scope: {
      selectedDataLayer: "=",
      selectedDistrict: "=",
      relativeIndicator: "=",
      absoluteIndicator: "="
    },
    link: function (scope, element) {
      var absoluteNumberFormat = germanNumberFormat(',.0f');
      /**
       * update the chart from one of the watchers
       */
      var rerender = function () {
        if (!scope.selectedDistrict || !scope.selectedDataLayer || angular.equals(scope.selectedDataLayer, {}) || !scope.selectedDataLayer[scope.selectedDistrict.uid]) {
          return;
        }
        scope.relativeValue = scope.selectedDataLayer[scope.selectedDistrict.uid][scope.relativeIndicator];
        scope.absoluteValue = absoluteNumberFormat(scope.selectedDataLayer[scope.selectedDistrict.uid][scope.absoluteIndicator]);
      };

      var layerWatcher = scope.$watch('selectedDataLayer', rerender);
      var districtWatcher = scope.$watch('selectedDistrict', rerender);

      // remove watcher on destroy
      element.on('$destroy', function () {
        layerWatcher();
        districtWatcher();
      });
    }
  };
}).filter('germanNumber', function(d3) {
  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat,
      numberFormat = germanNumberFormat(',.1f');
  return function(number) {
    return numberFormat(number);
  };
});
